import { Field, Float, ID, ObjectType } from 'type-graphql'
import type { GetArgs } from '../repository/types'
import type { IAction } from '../action/IAction'
import type { Order } from '../order/Order'

/**
 * One company's AR aging breakdown — also the shape of the grand-total footer
 * row. Each money field is the summed outstanding balance landing in that
 * days-past-due bucket; `total` is the sum of the buckets.
 */
@ObjectType()
export class ArAgingRow {
  @Field(() => ID)
  companyId: string

  @Field(() => String)
  companyName: string

  @Field(() => Float)
  current: number

  @Field(() => Float)
  d1to30: number

  @Field(() => Float)
  d31to60: number

  @Field(() => Float)
  d61to90: number

  @Field(() => Float)
  d90plus: number

  @Field(() => Float)
  total: number
}

export interface IGetArAgingReportTotals extends IAction<ArAgingRow, GetArgs<Order>> {}
